import {
  ListAvailabilityTimeSlotsRequest,
  ListAvailabilityTimeSlotsResponse,
} from '@wix/ambassador-bookings-availability-v2-time-slot/types';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { listAvailabilityTimeSlots as listAvailabilityTimeSlotHttpRequest } from '@wix/ambassador-bookings-availability-v2-time-slot/http';
import {
  panoramaQueryAvailabilityInteractionStart,
  panoramaQueryAvailabilityInteractionEnd,
} from '../../utils/panorama/panorama';
import { PanoramaTransactions } from '../../utils/panorama/consts';

export const listAvailabilityTimeSlots = async (
  listAvailabilityTimeSlotRequest: ListAvailabilityTimeSlotsRequest,
  flowAPI: ControllerFlowAPI,
): Promise<ListAvailabilityTimeSlotsResponse> => {
  await panoramaQueryAvailabilityInteractionStart({
    flowAPI,
    request: listAvailabilityTimeSlotRequest,
    transaction: PanoramaTransactions.availabilityTimeSlotsSingleService,
  });

  try {
    const response = (
      await flowAPI.httpClient.request(
        listAvailabilityTimeSlotHttpRequest(listAvailabilityTimeSlotRequest),
      )
    ).data;

    await panoramaQueryAvailabilityInteractionEnd({
      flowAPI,
      response,
      transaction: PanoramaTransactions.availabilityTimeSlotsSingleService,
      request: listAvailabilityTimeSlotRequest,
    });

    return response;
  } catch (e) {
    throw e;
  }
};